import React from 'react';

export default function Close(props) {
  return (
    <svg
      height="38"
      viewBox="0 0 38 38"
      width="38"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}>
      <path
        d="m19 37c9.9411255 0 18-8.0588745 18-18s-8.0588745-18-18-18-18 8.0588745-18 18 8.0588745 18 18 18zm-7.5-10.5 15-15m-15 0 15 15"
        fill="none"
        stroke="#000"
        strokeColor="red"
        strokeLinecap="round"
        strokeWidth="1.7"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/close.js